module.exports = __webpack_public_path__ + "img/普陀男.ff2f19ca.png";